module.exports = __webpack_public_path__ + "gg.svg?c447047f465ae1303de6e46c43eb0a6a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/gg.svg
// module id = 1115
// module chunks = 0